import React, { useState, useEffect } from "react";
import {
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RecordNotFoundNoNewNotification from "../../../common/RecordNotFoundNoNewNotification";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
const Spare = (props) => {
    const { notificationRecords, totalElements, handleChangePage, handleChangeRowsPerPage, rowsPerPage, page,setSpareLength ,handleMoveToReadFunc} = props;
    const [brodcastList, setBrodcastList] = useState([]);
    const [ids, setIds] = useState([]);
    const [prevLocalIds, setPrevLocalIds] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        setBrodcastList(notificationRecords)
    }, [notificationRecords, totalElements, handleChangePage, handleChangeRowsPerPage, rowsPerPage, page])

    useEffect(() => {
        var localFields = JSON.parse(localStorage.getItem("NotifySpare"));
        if (localFields) {
            setIds(localFields)
        }
    }, [])

    const handleClickTitle = (id) => {
        var localFields = JSON.parse(localStorage.getItem("NotifySpare"));
        setPrevLocalIds(localFields)
        
        if ((ids.indexOf(id) || localFields?.includes(id)) !== -1) {
        }
        else {
            ids.push(id)
            localStorage.setItem("NotifySpare", JSON.stringify(ids));
        }
    }
    return (
        <>
            {brodcastList && brodcastList.length > 0 ? (brodcastList.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
            )).map((row, index) => {
                return (
                    <Accordion className={(localStorage.getItem('NotifySpare')?.includes(row.id) || prevLocalIds?.includes(row.id)) ? 'checkedNotification' : ''} sx={{ borderLeft: 7, p: 0, borderColor: "#003f93", mb: 1,textAlign:"left" }} key={row.id}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            onClick={() => {
                                 handleClickTitle(row.id)
                                 handleMoveToReadFunc('2',row.id)
                                 }}
                            className="notification_title"

                        >
                            <Typography sx={{textTransform:"capitalize"}}>{row.title}  </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                {row.content}

                            </Typography>
                            <Typography sx={{ textAlign: "right"}}>
                                <ArrowRightAltIcon
                                    fontSize="large"
                                    sx={{ color: "#003f93" ,cursor:"pointer"}}
                                    onClick={() => navigate(
                                        `/spare-details-view/${row?.notificationTypeId}`,
                                        {
                                            state: {
                                              pageNo: page,
                                              typeId: 2,
                                              fromNotification:true,
                                              isFromRead : false
                                            },
                                          }
                                    )}
                                />
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                )
            })
                : <RecordNotFoundNoNewNotification />
            }

        </>
    );
};

export default Spare;
